import {
  AUDIT_ACTION_LABELS,
  AUDIT_ORIGIN_LABELS,
  AUDIT_TRAIL_PAGE_SIZE,
  ENTITLEMENT_LABELS,
} from 'constants/entitlements/entitlements';
import {
  EntitlementAuditRecord,
  EntitlementAuditTrailRow,
  StoreSummary,
} from 'types/entitlements/entitlements';

/**
 * One row per audit record, newest first as CentsBE returns them. A store missing from the name list
 * (a residential location, say) still gets a row, named by id, as the store table does.
 */
export function buildAuditTrailRows(
  stores: StoreSummary[],
  records: EntitlementAuditRecord[],
): EntitlementAuditTrailRow[] {
  const namesById = new Map(stores.map(({ id, name }) => [id, name]));

  return records.map(({ id, createdAt, storeId, slug, actionType, origin, actor, reason }) => ({
    id,
    createdAt,
    storeName: namesById.get(storeId) ?? `Store #${storeId}`,
    entitlement: ENTITLEMENT_LABELS[slug] ?? slug,
    action: AUDIT_ACTION_LABELS[actionType] ?? actionType,
    origin: AUDIT_ORIGIN_LABELS[origin] ?? origin,
    actor: actor?.name ?? '',
    reason,
  }));
}

/**
 * The row count the server-paged grid needs, from what is known without a total: every row up to
 * this page, plus one when `hasMore`. That enables "next" exactly when CentsBE says a later page has
 * records, without claiming a total nobody computed.
 *
 * `page` is 1-based, as the API counts it.
 */
export function getAuditTrailRowCount(page: number, rowsOnPage: number, hasMore: boolean): number {
  return (page - 1) * AUDIT_TRAIL_PAGE_SIZE + rowsOnPage + (hasMore ? 1 : 0);
}
